<template>
  <div class="login">
    <p>松材线虫病疫木监测平台</p>
        <!-- <i class="treeIcon"></i> -->
    <div class="form">
      <div class="form-input">
        <input type="text" placeholder="输入手机号码" v-model="loginForm.phone" class="phone">
        <input type="password" placeholder="输入密码" v-model="loginForm.password" class="code">
        <!-- <div class="time" @click="countDown">
          {{content}}
        </div> -->
      </div>
      <div class="btn" style="margin-top: 20px">
        <button @click="login">登录</button>
      </div>

    </div>
  </div>
</template>

<script>
  import {Toast} from 'vant'
  import {getCode, userLogin} from '../api/api'
  import {mapMutations} from "vuex"
  export default {
    data() {
      return {
        loginForm: {
          phone: '',
          password: '',
        },
        checked: false,
        content: '发送验证码',
        totalTime: 30,
        canClick: true, //添加canClick,
        scrollTop: ""
      }
    },

    mounted() {
      window.addEventListener("scroll", this.handleScroll);
      const inp = document.getElementsByTagName("input");
      Array.from(inp).map(item => {
        item.onblur = () => {
          window.scrollTo(0, 0);
        };
        item.onfocus = () => {
          window.scrollTo(0, this.scrollTop);
        };
      });
    },
    methods: {
      handleScroll(){
        var scrollTop =  window.pageYOffset ||  document.documentElement.scrollTop ||   document.body.scrollTop;
        if (scrollTop > 0) {
          this.scrollTop = scrollTop;
        }
      },
      //获取验证码
      async getCode() {
        let param = {
          phone: this.loginForm.phone
        }
        getCode(param).then((res) => {
          if(res.data.code === 600){
            Toast.success('验证码发送成功，请查收');
          }else {
            Toast.fail(res.data.msg);
            return
          }
        })

      },
      //登录
      ...mapMutations(['setToken']),
      async login() {
        const {phone, password} = this.loginForm
        let params = {
          phone: phone,
          password: password
        }
        userLogin(params).then(res => {
          if(res.data.code === 600){
            Toast.success('登录成功');
            localStorage.setItem("islogin", 1);
            localStorage.setItem("appUname", res.data.data.appUname);
            localStorage.setItem('appUid', res.data.data.appUid)
            localStorage.setItem('appUtype', res.data.data.appUtype)
            this.setToken({token:res.data.data.token})
            this.$router.push({
              path: './map',
              // query: {
              //   appUid: res.data.data.appUid,
              //   appUtype:res.data.data.appUtype
              // }
            })
          }else {
            Toast.fail(res.data.msg);
            return
          }
        })

      },
      //验证手机号
      checkMobile(number) {
        var partten = /^(13[0-9]|14[0-9]|15[0-9]|16[6]|18[0-9]|19[6,9]|17[0-9])\d{8}$/i;
        return partten.test(number);
      },
      //发送验证码
      countDown() {
        if (!this.loginForm.phone) {
          Toast.fail('手机号不能为空');
          return
        }
        if (!this.checkMobile(this.loginForm.phone)) {
          Toast.fail('手机号不正确');
          return
        }
        if (!this.canClick) return  //改动的是这两行代码
        this.canClick = false
        this.getCode()
        this.content = '已发送(' + this.totalTime + ')s'
        let clock = window.setInterval(() => {
          this.totalTime--
          this.content = '已发送(' + this.totalTime + ')s'
          if (this.totalTime < 0) {
            window.clearInterval(clock)
            this.content = '发送验证码'
            this.totalTime = 30
            this.canClick = true  //这里重新开启
          }
        }, 1000)
      }
    }
  }
</script>

<style lang="scss">
  .login {
    height: 100%;
     background: url('../assets/bg.png') center no-repeat;
    padding-top: 0.1px;
    p {
      font-size: 48px;
      font-weight:500;
      color: #0eB871;
      letter-spacing: 2px;
      margin: 268px 0 150px 0;
      text-align: center;
    }
    .treeIcon{
      display: inline-block;
      height: 150px;
      width: 150px;
      background-image: url('../assets/pineTree.png');
      background-size: cover;
    }
    .form-input, .btn {
      text-align: center;
    }
    .form-input {
      position: relative;
      .phone, .code {
        width: 560px;
        height: 94px;
        border: 3px solid #0eB871;
        border-radius: 10px;
        background: transparent;
        font-size: 32px;
        color: #349898;
        padding-left: 66px;
      }
      .phone {
        margin-bottom: 22px;
      }
      .time {
        position: absolute;
        right: 120px;
        top: 24px;
        font-size: 28px;
        color: #338d8d;
        cursor: pointer;
      }
      &:before {
        position: absolute;
        height: 46px;
        right: 276px;
        margin-top: 19px;
        z-index: 100;
        top: 0;
        display: block;
        // border: 1px solid #0eB871;
        content: ' ';

      }
    }

    .switch {
      padding-left: 87px;
      display: flex;
      align-items: center;
      margin: 26px 0 138px 0;
      span {
        margin-left: 28px;
      }
    }
    button {
      width: 560px;
      height: 94px;
      border-radius: 10px;
      background: #0eB871;
      color:#ffffff;
      font-size: 30px;
      letter-spacing: 10px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/login.vue